var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.$can('create', 'Security'))?_c('security-add-form'):_vm._e(),_c('securities-table',{on:{"selectRow":_vm.selectSecurity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }